import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/organic-impurities-reports")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/organic-impurities-reports", statusCode: 301 }); },
});
